import type { ReportFilter, ReportQueryRequest } from 'src/components/star-grid/api/reportEngineTypes';

export interface ReportViewKnobs {
  readonly filterOverrides: readonly ReportFilter[];
  readonly showBy?: string;
  readonly suppressZeroRows: boolean;
  readonly asOf?: string;
  readonly deckType?: string;
  /** View controls the session re-pointed, keyed by control id (`adjustment`, `currency`). */
  readonly viewOverrides?: Readonly<Record<string, string>>;
}

/** The viewer's query knobs, each sent only when it departs from the server default. */
export function reportQueryKnobs(knobs: ReportViewKnobs): Partial<ReportQueryRequest> {
  return {
    ...(knobs.filterOverrides.length > 0 ? { filter_overrides: [...knobs.filterOverrides] } : {}),
    ...(knobs.showBy ? { show_by: knobs.showBy } : {}),
    ...(knobs.suppressZeroRows ? {} : { suppress_zero_rows: false }),
    ...(knobs.asOf ? { as_of: knobs.asOf } : {}),
    ...(knobs.deckType ? { deck_type: knobs.deckType } : {}),
    ...(Object.keys(knobs.viewOverrides ?? {}).length > 0 ? { view_overrides: { ...knobs.viewOverrides } } : {})
  };
}

/** True while the view is the report's own default (nothing chosen yet, or only its own deck). */
export function isOpeningView(knobs: Partial<ReportQueryRequest>, ownDeck: string | undefined): boolean {
  const { deck_type: deck, ...rest } = knobs;
  return Object.keys(rest).length === 0 && (!deck || deck.toLowerCase() === (ownDeck ?? '').toLowerCase());
}
